<template>
  <div class="mt-[60px] lg:mt-[119px] overflow-hidden">
    <section class="max-w-[1316px] mx-auto px-[10px] py-[60px] md:py-[119px]">
      <Main />
    </section>
    <div class="bg-[#FFC107]">
      <section class="max-w-[1316px] mx-auto px-[10px] py-[60px]">
        <StatusCharts />
      </section>
    </div>
    <section class="max-w-[1316px] mx-auto px-[10px] py-[60px]">
      <Aspects />
    </section>
    <div class="bg-[#FFC107]">
      <section class="max-w-[1316px] mx-auto px-[10px] py-[60px]">
        <HROptimization />
      </section>
    </div>
    <section class="max-w-[1316px] mx-auto px-[10px] py-[60px]">
      <WhatsGets />
    </section>
    <div class="bg-[#FFC107]">
      <section class="max-w-[1316px] mx-auto px-[10px] py-[60px]">
        <NumbersLanguage />
      </section>
    </div>
    <section class="max-w-[1316px] mx-auto px-[10px] py-[60px]">
      <Feedback variant="light" />
    </section>
    <section class="max-w-[1316px] mx-auto px-[10px] py-[60px]">
      <SEO class="border-0" variant="light" />
    </section>
  </div>
</template>

<script setup lang="ts">
import Main from "~/components/wellbeing/Main.vue";
import StatusCharts from "~/components/wellbeing/StatusCharts.vue";
import Aspects from "~/components/wellbeing/Aspects.vue";
import HROptimization from "~/components/wellbeing/HROptimization.vue";
import WhatsGets from "~/components/wellbeing/WhatsGets.vue";
import NumbersLanguage from "~/components/wellbeing/NumbersLanguage.vue";
import Feedback from "~/components/landing/sections/Feedback.vue";
import SEO from "~/components/landing/sections/SEO.vue";


const { t } = useI18n();

definePageMeta({
  layout: 'default-light',
})

useSeoMeta({
  title: t('b2b.header.menu.wellbeing'),
  description: t('b2b.seo.index.description'),
})
</script>

<style scoped>

</style>